// extracted by mini-css-extract-plugin
module.exports = {"bannerContainer":"Banner_bannerContainer__1Jlqn","banner":"Banner_banner__Lcs5E"};